export const createQuantityOptions = (quantity: number) =>
  Array.from(Array(quantity).keys()).map((qty: number) => ({
    label: (qty + 1).toString(),
    value: qty + 1,
  }));
